import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { ConfirmationModalService } from 'src/app/services/confirmation-modal.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {

  applicationId: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private sessionStorage: SessionStorageService,
    private modalService: ConfirmationModalService,
    private store: Store
  ) {}

  ngOnInit(): void {

    this.store
      .select((state) => state)
      .subscribe((res) => {
        if (res) {
         this.applicationId = res?.application?.applicationId;
        }
      });
  }

  enableFeedback() {
    if(this.applicationId){
      return true;
    }

    return false;
  }

  // getFeedback() {
  //   this.modalService.feedbackModal();
  // }
  toggleContrast() {
    //this.theme.toggleContrast()
  }
  isProductOverview() {
    return window.location.href.includes('forms-overview');
  }

}
